// Inspections API Service
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const inspectionsApi = {
  // Create a new inspection
  async create(inspectionData) {
    try {
      const response = await axios.post(`${API_URL}/api/inspections/create`, inspectionData);
      return response.data;
    } catch (error) {
      console.error('Error creating inspection:', error);
      throw error;
    }
  },

  // Get all inspections for a user
  async list(userId, filters = {}) {
    try {
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.startDate) params.append('start_date', filters.startDate);
      if (filters.endDate) params.append('end_date', filters.endDate);
      
      const url = `${API_URL}/api/inspections/list/${userId}${params.toString() ? '?' + params.toString() : ''}`;
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error listing inspections:', error);
      throw error;
    }
  },

  // Get a single inspection
  async get(inspectionId) {
    try {
      const response = await axios.get(`${API_URL}/api/inspections/get/${inspectionId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting inspection:', error);
      throw error;
    }
  },

  // Update an inspection
  async update(inspectionId, updates) {
    try {
      const response = await axios.put(`${API_URL}/api/inspections/update/${inspectionId}`, updates);
      return response.data;
    } catch (error) {
      console.error('Error updating inspection:', error);
      throw error;
    }
  },

  // Start an inspection
  async start(inspectionId) {
    try {
      const response = await axios.post(`${API_URL}/api/inspections/start/${inspectionId}`);
      return response.data;
    } catch (error) {
      console.error('Error starting inspection:', error);
      throw error;
    }
  },

  // Complete an inspection
  async complete(inspectionId) {
    try {
      const response = await axios.post(`${API_URL}/api/inspections/complete/${inspectionId}`);
      return response.data;
    } catch (error) {
      console.error('Error completing inspection:', error);
      throw error;
    }
  },

  // Approve an inspection
  async approve(inspectionId, approvedBy = 'Manager') {
    try {
      const response = await axios.post(
        `${API_URL}/api/inspections/approve/${inspectionId}?approved_by=${encodeURIComponent(approvedBy)}`
      );
      return response.data;
    } catch (error) {
      console.error('Error approving inspection:', error);
      throw error;
    }
  },

  // Delete an inspection
  async delete(inspectionId) {
    try {
      const response = await axios.delete(`${API_URL}/api/inspections/delete/${inspectionId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting inspection:', error);
      throw error;
    }
  },

  // Get inspection statistics
  async getStats(userId) {
    try {
      const response = await axios.get(`${API_URL}/api/inspections/stats/${userId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting stats:', error);
      throw error;
    }
  },

  // Sync inspections from appointments
  async syncFromAppointments(userId, appointments) {
    try {
      const response = await axios.post(
        `${API_URL}/api/inspections/sync-from-appointments/${userId}`,
        appointments
      );
      return response.data;
    } catch (error) {
      console.error('Error syncing from appointments:', error);
      throw error;
    }
  }
};

export default inspectionsApi;
